import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tree-view',
  templateUrl: './tree-view.component.html',
  styleUrls: ['./tree-view.component.css']
})
export class TreeViewComponent implements OnInit {
  @Input() items:any;
  @Output() onItemSelected = new EventEmitter<any>();
  
  constructor() { }
  itemExpanded:boolean = false;
  ngOnInit() {

    
    
  }

  onTreeElementClicked(e:any, item:any) {
    // e.preventDefault();
    // e.stopPropagation();
    // e.stopImmediatePropagation();

    e.item = item;
    this.onItemSelected.emit(e);
  }

  onTreeItemClicked(e:any, item:any) {
    // e.preventDefault();
    // e.stopPropagation();
    // e.stopImmediatePropagation();

    this.onItemSelected.emit(e);
  }

  collapseToggle(e:Event, item:any){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    if((item && item.children && item.children.length > 0)) {
      console.log('here', item)
      item.collapsed =! item.collapsed;
    }
  }
}



// WEBPACK FOOTER //
// ./public/app/common/tree-view/tree-view.component.ts